import axios from 'axios';

import mainVersionOneService from './mainVersionOneService';

const CancelToken = axios.CancelToken;

let cancel;

export function portList() {
    return mainVersionOneService
        .get(`ports/list`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function defaultData(portId) {
    return mainVersionOneService
        .get(`ports/${portId}/defaultData`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function portDelete(portId) {
    return mainVersionOneService
        .delete(`ports/${portId}/delete`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
export function portSetDefaultValue(portId) {
    return mainVersionOneService
        .get(`ports/${portId}/setDefaultValue`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function portRecords(data) {
    if (cancel !== undefined) {
        cancel();
    }
    const formatFilter = (d) => {
        return Object.keys(d)
            .filter((v) => {
                return d[v] != null;
            })
            .map((v) => {
                return `${v}:${d[v]}`;
            })
            .join(',');
    };
    const formatSearch = (d) => {
        return Object.keys(d)
            .filter((v) => {
                return d[v] != null;
            })
            .map((v) => {
                return `${d[v]}`;
            })
            .join(',');
    };

    let parameters = '';

    for (const key in data) {
        const value = data[key];
        switch (key) {
            case 'order':
                parameters = `${parameters}&order=${value.type}.${value.order}`;
                break;
            case 'page':
                parameters = `${parameters}&page=${value}`;
                break;
            case 'limit':
                parameters = `${parameters}&limit=${value}`;
                break;
            case 'filter':
                if (Object.keys(value).length >= 1) {
                    parameters = `${parameters}&filter=${formatFilter(value)}`;
                }
                break;
            case 'search':
                if (Object.keys(value).length >= 1) {
                    parameters = `${parameters}&search=${formatSearch(value)}`;
                }
                break;
        }
    }

    return mainVersionOneService
        .get(`ports/records?rand=${new Date().getTime()}${parameters}`, {
            cancelToken: new CancelToken(function executor(c) {
                cancel = c;
            }),
        })
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function portRecord(portId, token = null) {
    if (token) {
        return mainVersionOneService
            .get(`ports/${portId}`, {
                headers: {
                    Authorization: 'Token ' + token,
                },
            })
            .then((res) => {
                return res.data;
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }
    return mainVersionOneService
        .get(`ports/${portId}`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
